import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { catchError, switchMap, map } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { of } from 'rxjs';
import { NetworkCallService } from '../../../core/services/network-call.service';
import * as login from '../actions/login.actions';
import { IBusinessLoginRequest, IBusinessLoginResponse } from '../models/business-login.model';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import notify from 'devextreme/ui/notify';

@Injectable()
export class LoginEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login.loadLoginRequest),
      switchMap(action => {

        return this.networkCallService.post<IBusinessLoginRequest, IBusinessLoginResponse>('Authentication/businessLogin', action.request).pipe(
          map(response => {
            if (response.success && !response.invalidMobileNumber && !response.locked) {
              localStorage.removeItem('MULTIPLE_ERROR_HANDLING');
              this.router.navigateByUrl('auth/otp');
            } else if (!response.success && response.locked) {
              this.helperService.notifyError('Your account has been locked', 300, 3000);
            } else if (!response.success && response.invalidMobileNumber) {
              this.helperService.notifyError('Invalid mobile number! Your mobile number is not valid', 400, 3000);
            } else if (!response.success) {
              this.helperService.notifyError('Please check your details and try again', 400, 3000);
            }
            return login.loadLoginSuccess({ response });
          }),
          retryTransientHttpErrors(),
          catchError(error => {
            // Skip error handling if 401 was already handled by interceptor
            return of(login.loadLoginFailure(error));
          })
        );
        }
      )
    )
  );
}
